module.exports = __webpack_public_path__ + "static/media/manage-manufacturers.2d466c4f.svg";